import { Component } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { getDayOfWeek } from '../../../iwIntlProvider/MessagesHelper';
import styles from './RepaymentSummaryItem.module.css';
import messages from './RepaymentSummaryItem.messages';
import { IwDynamicFormattedMessage } from '../../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';

class RepayDate extends Component {
    renderDate() {
        const { value, ...otherProps } = this.props;

        if (!value) {
            return null;
        }

        switch (this.props.interval) {
            case 'Weekly':
                const weekDay = (
                    <IwDynamicFormattedMessage
                        messages={messages}
                        messageKey={getDayOfWeek(value)}
                    />
                );
                return (
                    <div className={styles.RepayDate}>
                        <FormattedMessage
                            {...messages.weekly}
                            values={{ weekDay }}
                            {...otherProps}
                        />
                    </div>
                );

            case 'Monthly':
                return (
                    <div className={styles.RepayDate}>
                        <FormattedMessage
                            {...messages.monthly}
                            values={{ monthDay: value }}
                            {...otherProps}
                        />
                    </div>
                );

            default:
                return (
                    <FormattedDate
                        className={styles.RepayDate}
                        day="numeric"
                        month="long"
                        year="numeric"
                        {...this.props}
                        value={new Date(this.props.value)}
                    />
                );
        }
    }

    render() {
        return this.renderDate();
    }
}

// eslint-disable-next-line import/no-default-export
export default RepayDate;
